import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { Text } from '../../Text.js';
import { jsx } from 'react/jsx-runtime';
function generateRenderNodeOptions(nodeTypes) {
  const result = {};
  for (const nodeType of nodeTypes) {
    result[nodeType] = (_, children) => children;
  }
  return result;
}
function untagContentfulNode(node, nodeTypes) {
  return documentToReactComponents(node, {
    renderNode: generateRenderNodeOptions(nodeTypes)
  });
}
function overrideContentfulParagraphWrapping() {
  return {
    [BLOCKS.LIST_ITEM]: (node, _) => untagContentfulNode(node, [BLOCKS.PARAGRAPH]),
    [BLOCKS.QUOTE]: (node, _) => /*#__PURE__*/jsx(Text, {
      variant: "display2",
      as: "h2",
      children: untagContentfulNode(node, [BLOCKS.PARAGRAPH])
    })
  };
}
export { overrideContentfulParagraphWrapping, untagContentfulNode };
//# sourceMappingURL=overrideContentfulParagraphWrapping.js.map
